import ActionBarItem from "@rio-cloud/rio-uikit/ActionBarItem";
import SimpleTooltip from "@rio-cloud/rio-uikit/SimpleTooltip";
import useDarkMode from "@rio-cloud/rio-uikit/useDarkMode";
import {
  setColorScheme,
  THEME_CHANGE_EVENT,
  THEME_DARK,
  THEME_DATA_ATTRIBUTE,
  THEME_LIGHT,
} from "@rio-cloud/rio-uikit/ColorScheme";
import { useT } from "@hooks";

const getIframeOrigin = (iframe: HTMLIFrameElement) => {
  if (!iframe.src) return null;
  const { origin, protocol } = new URL(iframe.src, window.location.href);
  return protocol === "http:" || protocol === "https:" ? origin : null;
};

const notifyIframes = () => {
  Array.from(document.getElementsByTagName("iframe")).forEach((iframe) => {
    const origin = getIframeOrigin(iframe);
    if (origin) iframe.contentWindow?.postMessage(THEME_CHANGE_EVENT, origin);
  });
};

const ThemeToggle = () => {
  const t = useT();
  const isDarkMode = useDarkMode();
  const label = t(isDarkMode ? "header.themeToggle.toLight" : "header.themeToggle.toDark");

  const toggleTheme = () => {
    const scheme = isDarkMode ? THEME_LIGHT : THEME_DARK;
    setColorScheme(scheme);
    document.documentElement.setAttribute(THEME_DATA_ATTRIBUTE, scheme);
    notifyIframes();
  };

  return (
    <ActionBarItem id="theme-toggle" className="ThemeToggleItem">
      <ActionBarItem.Icon>
        <SimpleTooltip content={label} placement="bottom">
          <button
            type="button"
            className={`ThemeToggle ${isDarkMode ? "is-dark" : "is-light"}`}
            aria-pressed={isDarkMode}
            onClick={toggleTheme}
          >
            <span className="icon rioglyph rioglyph-mode-dark-light" aria-hidden="true" />
            <span className="ThemeToggle-label">{t("header.themeToggle.label")}</span>
          </button>
        </SimpleTooltip>
      </ActionBarItem.Icon>
    </ActionBarItem>
  );
};

export default ThemeToggle;
